import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { postApi, getApi, putApi, deleteApi } from "common/services/api"
import { API_PATHS } from "common/services/apiPaths"
import { toast } from "react-toastify"

// Async thunk for creating interview
export const postInterview = createAsyncThunk(
  "interview/postInterview",
  async ({ values, resetForm, navigate }, { rejectWithValue }) => {
    try {
      const response = await postApi(API_PATHS.RECRUITMENT_INDIVIDUAL_INTERVIEW, values)
      if (response.status === 201) {
        toast.success("Interview created successfully!")
        resetForm()
        navigate("/recruitment/interviews")
      }
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || "Something went wrong"
      toast.error(errorMessage)
      return rejectWithValue(errorMessage)
    }
  },
)

// Async thunk for updating interview
export const updateInterview = createAsyncThunk(
  "interview/updateInterview",
  async ({ id, values, navigate }, { rejectWithValue }) => {
    try {
      const response = await putApi(`${API_PATHS.RECRUITMENT_INDIVIDUAL_INTERVIEW}${id}`, values)
      console.log(response,'response324543');
      
      if (response.status === 200) {
        toast.success("Interview updated successfully!")
        navigate("/recruitment/interviews")
      }
      return response.data
    } catch (error) {
      console.log(error,'errorqwe43');
      
      const errorMessage = error.response?.data?.message || error.response?.data?.error || "Something went wrong"
      toast.error(errorMessage)
      return rejectWithValue(errorMessage)
    }
  },
)

// Async thunk for fetching interviews
export const fetchInterviews = createAsyncThunk("interview/fetchInterviews", async (_, { rejectWithValue }) => {
  try {
    const response = await getApi(API_PATHS.RECRUITMENT_INDIVIDUAL_INTERVIEW)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to fetch interviews"
    toast.error(errorMessage)
    return rejectWithValue(errorMessage)
  }
})

// Async thunk for fetching single interview
export const fetchInterviewById = createAsyncThunk("interview/fetchInterviewById", async (id, { rejectWithValue }) => {
  try {
    const response = await getApi(`${API_PATHS.RECRUITMENT_INDIVIDUAL_INTERVIEW}/${id}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to fetch interview"
    toast.error(errorMessage)
    return rejectWithValue(errorMessage)
  }
})

// Async thunk for deleting interview
export const deleteInterview = createAsyncThunk("interview/deleteInterview", async (id, { rejectWithValue }) => {
  try {
    const response = await deleteApi(`${API_PATHS.RECRUITMENT_INDIVIDUAL_INTERVIEW}/${id}`)
    if (response.status === 200) {
      toast.success("Interview deleted successfully!")
    }
    return { id, data: response.data }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to delete interview"
    toast.error(errorMessage)
    return rejectWithValue(errorMessage)
  }
})

const interviewSlice = createSlice({
  name: "interview",
  initialState: {
    interviews: [],
    currentInterview: null,
    loading: false,
    error: null,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearCurrentInterview: (state) => {
      state.currentInterview = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Create interview
      .addCase(postInterview.pending, (state) => {
        state.createLoading = true
        state.error = null
      })
      .addCase(postInterview.fulfilled, (state, action) => {
        state.createLoading = false
        state.interviews.push(action.payload.data)
      })
      .addCase(postInterview.rejected, (state, action) => {
        state.createLoading = false
        state.error = action.payload
      })

      // Update interview
      .addCase(updateInterview.pending, (state) => {
        state.updateLoading = true
        state.error = null
      })
      .addCase(updateInterview.fulfilled, (state, action) => {
        state.updateLoading = false
        const index = state.interviews.findIndex((interview) => interview?._id === action?.payload?.data?._id)
        if (index !== -1) {
          state.interviews[index] = action.payload.data
        }
        state.currentInterview = action?.payload?.data
      })
      .addCase(updateInterview.rejected, (state, action) => {
        state.updateLoading = false
        state.error = action.payload
      })

      // Fetch interviews
      .addCase(fetchInterviews.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchInterviews.fulfilled, (state, action) => {
        state.loading = false
        state.interviews = action.payload.data || []
      })
      .addCase(fetchInterviews.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Fetch interview by ID
      .addCase(fetchInterviewById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchInterviewById.fulfilled, (state, action) => {
        state.loading = false
        state.currentInterview = action.payload.data
      })
      .addCase(fetchInterviewById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Delete interview
      .addCase(deleteInterview.pending, (state) => {
        state.deleteLoading = true
        state.error = null
      })
      .addCase(deleteInterview.fulfilled, (state, action) => {
        state.deleteLoading = false
        state.interviews = state.interviews.filter((interview) => interview?._id !== action.payload.id)
      })
      .addCase(deleteInterview.rejected, (state, action) => {
        state.deleteLoading = false
        state.error = action.payload
      })
  },
})

export const { clearError, clearCurrentInterview } = interviewSlice.actions
export default interviewSlice.reducer
